/**
 * Created by alex.y on 8/8/2017.
 */
export enum TariffSource{
    Canada = 0,
    Usa = 1
}


// WEBPACK FOOTER //
// ./app/objects/tariffs/tariffSource.ts